if (!customElements.get('osenu-product-assurance')) {
  class OsenuProductAssurance extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = [...dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(element => !element.disabled && element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        });
        dialog.addEventListener('click', event => {
          const bounds = dialog.getBoundingClientRect();
          const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
          if (event.target.closest('[data-osenu-service-close]') || event.target === dialog && outside) dialog.close();
        });
        dialog.addEventListener('close', () => {
          if (!document.querySelector('.osenu-service-dialog[open]')) document.documentElement.classList.remove('osenu-service-dialog-open');
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        });
      });
      this.updateOrderDate();
      this.dateTimer = setInterval(() => this.updateOrderDate(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.dateTimer);
      if (!document.querySelector('.osenu-service-dialog[open]')) document.documentElement.classList.remove('osenu-service-dialog-open');
    }
    updateOrderDate() {
      const date = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'Europe/London' }).format(new Date());
      this.querySelectorAll('[data-osenu-order-date]').forEach(element => { element.textContent = date; });
    }
    openPanel(name, trigger) {
      const dialog = [...this.querySelectorAll('[data-osenu-service-panel]')].find(element => element.dataset.osenuServicePanel === name);
      if (!dialog) return;
      const previous = this.querySelector('dialog[open]');
      const origin = trigger?.closest('dialog') ? this.returnFocus : trigger;
      if (previous === dialog) return;
      previous?.close();
      this.returnFocus = origin;
      if (trigger) trigger.setAttribute('aria-controls', dialog.id);
      dialog.showModal();
      dialog.querySelector('.osenu-service-dialog__body').scrollTop = 0;
      document.documentElement.classList.add('osenu-service-dialog-open');
    }
  }
  customElements.define('osenu-product-assurance', OsenuProductAssurance);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-osenu-service-open]');
    const anchor = event.target.closest('a[href]');
    const owner = trigger?.closest('osenu-product-assurance') || document.querySelector('#MainContent .product-details osenu-product-assurance');
    if (!owner) return;
    let panel = trigger?.dataset.osenuServiceOpen;
    if (!panel && anchor && anchor.closest('#MainContent, .osenu-service-dialog')) {
      const path = new URL(anchor.href, location.href).pathname;
      if (owner.dataset.shippingUrl && path === new URL(owner.dataset.shippingUrl, location.href).pathname) panel = 'delivery';
      else if (owner.dataset.returnsUrl && path === new URL(owner.dataset.returnsUrl, location.href).pathname) panel = 'returns';
    }
    if (!panel) return;
    event.preventDefault();
    owner.openPanel(panel, trigger || anchor);
  });
}
